<template>
<div class="chapter">
<div class="inner_page">
<div class="part" id="part01">
<h1><a href="#/004toc#january">JANUARY</a></h1>
<p class="center">The Month of Plagues</p>
<p class="white1"></p>
<div class="image" id="image2">
<p class="center"><img alt="image 2" src="images/image-5.jpg"/></p>
<p class="white1"></p>
</div>
<p class="center"><b>Capricorn:</b> January 1–20 • <b>Aquarius:</b> January 21–31</p>
<div class="image" id="image3">
<p class="center"><img alt="image 3" src="images/image-5b.jpg"/></p>
</div>
<p class="center"><b>Plant to Avoid:</b> Wolfsbane</p>
<p class="center"><b>Doomsday Device:</b> Icicle machine gun</p>
<p class="center"><b>Evil Omen:</b> Pentagram-shaped snowflake</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 005part01.vue?6cc258cb